import { Injectable } from '@angular/core';
import { Popup } from './popup';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandler {
  constructor(private popup: Popup) {}

  handle(error: any) {
    let message = 'An unexpected error occurred';
    if (error.status === 0) message = 'Network error';
    else if (error.status === 401) message = 'Unauthorized — please log in';
    else if (error.error?.message) message = error.error.message;

    this.popup.show({
      message,
      type: 'error',
      position: 'top',
    });

    return throwError(() => error);
  }
}
